import { MutationTree } from 'vuex';
import { Waiting, WaitingState } from '@/store/waitings/types';

const mutations: MutationTree<WaitingState> = {
  fetchedWaitings(state, waitings: Waiting[]) {
    state.waitings = waitings
  },
};

export default mutations;
